import { Polyline } from 'react-leaflet';

    
export const drawPillarConnections = (markers, connections) => {
    return connections.map((connection, index) => {
        const pillar = markers.find(m => m[0] === connection.PillarID);
        const lamp = markers.find(m => m[0] === connection.LampID);
        if (pillar && lamp && pillar[2] && pillar[3] && lamp[2] && lamp[3]) {
            return (
                <Polyline
                    key={`line-${index}`}
                    positions={[[parseFloat(pillar[2]), parseFloat(pillar[3])], [parseFloat(lamp[2]), parseFloat(lamp[3])]]}
                    pathOptions={{ color: "blue", weight: 3, opacity: 2 }}
                />
            );
        }

        return null;
    });
};

export const drawPillarConnection = (pillar) => {
    return pillar.connections.map((destination, idx) => {
        return (
            <Polyline
                key={`polyline-${pillar.id}-${idx}`}
                positions={[[pillar.lat, pillar.lng], destination]}
                pathOptions={{ color: 'red', weight: 3, opacity: 0.8 }}
            />

        )
    })
}

export const drawPillarConnectionManagement = (pillar) => {
    return pillar.pillarInfo.map((destination, idx) => {
        return (
            <Polyline
                key={`polyline-${pillar.id}-${idx}`}
                positions={[[pillar.lat, pillar.lng], destination]}
                pathOptions={{ color: 'red', weight: 3, opacity: 0.8 }}
            />

        )
    })
}

export const drawStreetPolylines = (streets) => {
    return streets?.map((street) => (
        street.path.slice(0, -1).map((point, index) => {
            const nextPoint = street.path[index + 1]["location"];
            const popupContent = `
                <div style="font-family: Arial, sans-serif; padding: 8px;">
                    <h4 style="margin-bottom: 12px; color: #333;">Street Information</h4>
                    <p><strong>Κωδικός ID Οδού:</strong> ${street.id}</p>
                    <p><strong>Ονομασία Οδού:</strong> ${street.name}</p>
                    <p><strong>Τυπικό μοντέλο:</strong> ${street.model}</p>
                    <p><strong>Κλάση Φωτισμού:</strong> ${street.class}</p>
                    <p><strong>Παρατηρήσεις:</strong><br>${street.comments?.replace(/\n/g, '<br>')}</p>
                    ${street.links?.length > 0 ? 
                    `<p><strong>Σύνδεσμος PDF:</strong><br>
                    <a href="${street.links[0]}" target="_blank">${street.model}.pdf</a></p>` : ''}
                </div>`;
    
            return (
                <Polyline
                    key={`${street.street_id}-${index}`}
                    positions={[
                        [point["location"].latitude, point["location"].longitude],
                        [nextPoint.latitude, nextPoint.longitude]
                    ]}
                    pathOptions={{ color: "blue", weight: 3, opacity: 2.5 }}
                    eventHandlers={{
                        click: (e) => {
                            const layer = e.target;
                            layer.bindPopup(popupContent).openPopup();
                        }
                    }}
                />
            );
        })
    ));
};
